import { Screen } from '@/ui/core/screen'
import { View, useWindowDimensions } from 'react-native'

import { AppHeader } from '@/components/AppHeader'
import { ProfileInfoForm } from '@/components/ProfilePage/ProfileInfoForm'
import ProtectedPage from '@/components/ProtectedPage'
import { LogoColorVariant } from '@/components/svgs/Logo'
import { HStack } from '@/ui/core/stack'

const MobileProfileView = () => {
	return (
		<ProtectedPage>
			<AppHeader className="bg-color-palette_1" logoColor={LogoColorVariant.BRIGHT} />
			<Screen
				preset="fixed"
				className="flex flex-1 w-full justify-center"
				contentContainerClassName="justify-center"
				StatusBarProps={{ style: 'light' }}
			>
				<View className="px-12">
					<ProfileInfoForm />
				</View>
			</Screen>
		</ProtectedPage>
	)
}

const DesktopProfileView = () => {
	return (
		<ProtectedPage>
			<AppHeader className="bg-color-palette_1" logoColor={LogoColorVariant.BRIGHT} />
			<HStack fullHeight>
				<Screen preset="auto" className="flex flex-1">
					<View className="flex flex-1 w-full justify-center">
						<View className="px-[20%] lg:px-[33%]">
							<ProfileInfoForm />
						</View>
					</View>
				</Screen>
			</HStack>
		</ProtectedPage>
	)
}

export default function SettingsScreen() {
	const { width } = useWindowDimensions()

	const showMobileView = width < 800

	return showMobileView ? <MobileProfileView /> : <DesktopProfileView />
}
